import BaseApiClient from '../BaseApiClient';

import { RoleSelectInterface } from '@interfaces/Role.interface';

export class ApiRole extends BaseApiClient {
  /**
   * Gets all items
   */
  async list(): Promise<Array<RoleSelectInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/role')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { roleQueryKeys } from './query-keys';
export { useRoleSelectListQuery } from './use-role-queries';
